"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyOrdersOp = exports.CanceledBy = exports.notCancellableOrderStatus = exports.ongoingOrderStatus = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    // When the order has been created, but the
    // offer it is trying to order has not been reserved
    OrderStatus["Created"] = "created";
    // The order has successfully reserved the offer
    OrderStatus["AwaitingPayment"] = "awaiting:payment";
    // The provider has to approve an order
    OrderStatus["AwaitingApproval"] = "awaiting:approval";
    //  The order cannot be completed until it has been picked up
    OrderStatus["AwaitingPickup"] = "awaiting:pickup";
    // The order has reserved the offer and the user has
    // provided payment successfully
    OrderStatus["Complete"] = "complete";
    // When the user has canceled the order.
    // The order expires before approval or completeness too.
    OrderStatus["Canceled"] = "canceled";
    OrderStatus["Unrecognized"] = "unrecognized";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
exports.ongoingOrderStatus = [
    OrderStatus.Created,
    OrderStatus.AwaitingPayment,
    OrderStatus.AwaitingApproval,
    OrderStatus.AwaitingPickup
];
exports.notCancellableOrderStatus = [
    OrderStatus.Canceled,
    OrderStatus.AwaitingPickup,
    OrderStatus.Complete
];
var CanceledBy;
(function (CanceledBy) {
    CanceledBy["OfferOwner"] = "offer:owner";
    CanceledBy["Buyer"] = "buyer";
    CanceledBy["Expiration"] = "expiration";
})(CanceledBy || (exports.CanceledBy = CanceledBy = {}));
var MyOrdersOp;
(function (MyOrdersOp) {
    MyOrdersOp["AsBuyer"] = "as:buyer";
    MyOrdersOp["AsSeller"] = "as:seller";
})(MyOrdersOp || (exports.MyOrdersOp = MyOrdersOp = {}));
